import {Dropdowns} from "./Dropdowns";
import {Modals} from "../Modals";
import {Stripe} from "../Stripe";
import RunningTotals from "../Financials/RunningTotals";
import {OrderValidation} from "../OrderValidation";
import {Alerts} from "../Alerts";

export class DropdownParams {

    static create(params, $element) {

        return {
            delimiter: ',',
            persist: false,
            create: function (input) {
                let valueKey = $element.data('src') !== undefined ? $element.data('src-value') ?? 'id' : 'value',
                    labelKey = $element.data('src') !== undefined ? $element.data('src-label') ?? 'name' : 'text'

                return {
                    [valueKey]: input,
                    [labelKey]: input,
                }
            }
        }
    }

    static createUnique(params, $element) {

        return {
            delimiter: ',',
            persist: false,
            create: function (input,) {
                let valueKey = $element.data('src') !== undefined ? $element.data('src-value') ?? 'id' : 'value',
                    labelKey = $element.data('src') !== undefined ? $element.data('src-label') ?? 'name' : 'text'

                if (!Object.values(this.options).some(option => option['name'].toLowerCase() === input.toLowerCase()))
                    return {
                        [valueKey]: input,
                        [labelKey]: input,
                    }
                else {
                    if ($element.prev().is('span.text-danger'))
                        $element.prev().remove()

                    $('<span class="text-danger">' + input + ' already exists</span>').insertBefore($element)

                    return false;
                }
            },
            onChange: function (value) {
                if ($element.prev().is('span.text-danger'))
                    $element.prev().remove()
            }
        }
    }

    static createCustomer(params) {

        return {
            delimiter: ',',
            valueField: 'id',
            labelField: 'fullname',
            searchField: ['fullname', 'postcode'],
            persist: false,
            create: function (input) {
                Modals.show('/customers/create', 'addCustomerCard', false, function (modal) {
                    let name = input.split(" ");

                    if (name[0] !== typeof undefined)
                        modal.find('[name="first_name"]').val(name[0]);

                    if (name[1] !== typeof undefined)
                        modal.find('[name="last_name"]').val(name[1]);

                    if ($('.order-customer-group').val())
                        modal.find('[name="customer_group_id"]').attr('data-selected', $('.order-customer-group').val())

                    modal.find('form').attr('data-on-success', 'customerCreateSelectize');
                }, function (modal) {
                    let sApi = $('#inputCustomer')[0].selectize
                    sApi.unlock();
                });
            },
            onChange: function (value) {
                let $customerCreditNotesElement = $('#inputCreditNotes'), sApiCreditNotes;
                if ($customerCreditNotesElement.length)
                    sApiCreditNotes = $customerCreditNotesElement[0].selectize;


                let $shippingElement = $('#inputShipping');
                let $shippingElementBtn = $('#inputShippingBtn');

                let $customerGroupElement = $('#inputCustomerGroup');

                let $customerEmailElement = $('#inputCustomerEmail');

                let $billingElement = $('#inputBilling');
                let $billingElementBtn = $('#inputBillingBtn');
                let $billingElementEditBtn = $('#inputBillingEditBtn');

                let $confirmOrderBtn = $('#confirmOrder');

                let $paymentElement = $('#payment_type'), paymentApi = $paymentElement[0].selectize

                let $productRepeater = $('[data-init="initJRepeaterProducts"]');

                let customer_id = value;
                let customer = this.options[value];
                let sApiBilling = $billingElement[0].selectize;
                let sApiShipping;


                //Stripe disabled when guest
                paymentApi.updateOption('Stripe', {...paymentApi.options['Stripe'], ...{'disabled': true}})

                //Stripe enabled when customer used
                if (customer)
                    delete paymentApi.options['Stripe']['disabled']

                if ($customerEmailElement.length) {
                    $customerEmailElement.val('')
                    if (customer)
                        $customerEmailElement.val(customer.email);
                }

                if ($confirmOrderBtn.length) {
                    $confirmOrderBtn.attr('href', '/orders/setup-payment/' + value);
                }

                if ($shippingElement.length) {
                    sApiShipping = $shippingElement[0].selectize;
                }

                if ($customerGroupElement.length) {
                    let $customerGroupElementSAPI = $customerGroupElement[0].selectize;
                    if (customer_id) {
                        // $customerGroupElementSAPI.disable();
                        $customerGroupElementSAPI.setValue(customer.customer_group_id);
                    } else {
                        $customerGroupElementSAPI.clear();
                        $customerGroupElementSAPI.enable();
                    }
                }

                //When changing back to guest account handle the addresses
                if(!customer_id) {

                    $billingElementEditBtn.addClass('disabled')
                    sApiBilling.disable();
                    sApiBilling.clear();
                    sApiShipping.clear();
                    sApiShipping.disable();

                    return false;

                }

                $('#replicate_billing').prop('checked', false);


                if ($shippingElement.length) {
                    sApiShipping.load(function (callback) {
                        let shipping_selected_address = $shippingElement.data('selected');
                        if (shipping_selected_address === undefined) {
                            this.clear();
                            this.clearOptions();
                            this.settings.placeholder = 'Please select an address';
                            this.updatePlaceholder();
                        } else {
                            $shippingElement.removeData('selected');
                        }
                        this.enable();
                        $shippingElementBtn.prop('href', '/customers/' + customer_id + '/addresses/create');
                        $shippingElementBtn.removeClass('disabled');
                        Dropdowns.selectizeAxiosLoad($shippingElement, '/api/customers/get-addresses/' + customer_id, sApiShipping, function (data) {
                            callback(data);
                            console.log(data, 'addresses')
                            data.forEach(function (address) {
                                if (address.default_shipping)
                                    sApiShipping.setValue(address.id);
                            })
                        }, '');
                    });

                    sApiShipping.refreshItems();
                }

                sApiBilling.load(function (callback) {
                    let billing_selected_address = $billingElement.data('selected');
                    if (billing_selected_address === undefined) {
                        this.clear();
                        this.clearOptions();
                        this.settings.placeholder = 'Please select an address';
                        this.updatePlaceholder();
                    } else {
                        $billingElement.removeData('selected');
                    }
                    this.enable();
                    $billingElementBtn.prop('href', '/customers/' + customer_id + '/addresses/create');
                    $billingElementBtn.removeClass('disabled');
                    Dropdowns.selectizeAxiosLoad($billingElement, '/api/customers/get-addresses/' + customer_id, sApiBilling, function (data) {
                        callback(data);
                        if (!data.length)
                            sApiBilling.disable()
                        data.forEach(function (address) {
                            if (address.default_billing)
                                sApiBilling.setValue(address.id);
                        })
                    }, '');
                });

                sApiBilling.refreshItems();


                if ($customerCreditNotesElement.length > 0) {
                    sApiCreditNotes.clear();
                    sApiCreditNotes.clearOptions();
                    sApiCreditNotes.load(function (callback) {
                        this.clear();
                        this.clearOptions();
                        this.settings.placeholder = 'No Credit Notes Found on Customer Account';
                        this.updatePlaceholder();

                        Dropdowns.selectizeAxiosLoad($customerCreditNotesElement, '/api/credit-notes/' + customer_id, sApiCreditNotes, function (data) {
                            callback(data);
                            if (data.length > 0) {
                                sApiCreditNotes.enable();
                                sApiCreditNotes.settings.placeholder = 'Credit Notes Found';
                                sApiCreditNotes.updatePlaceholder();
                            } else {
                                sApiCreditNotes.disable();
                                sApiCreditNotes.settings.placeholder = 'No Credit Notes Found on Customer Account';
                                sApiCreditNotes.updatePlaceholder();
                            }
                        }, '');
                    });
                }

                // let list = $('[data-repeater-list="items"]').children();
                //
                // list.each((index, $item) => {
                //     if (index !== 0) {
                //         let itemType = $('.itemType', $item).val();
                //         let productID = $('.itemID', $item).val();
                //         if (itemType === 'product') {
                //             let price_api_url = `/api/products/get-price/${productID}`;
                //             axios.get(price_api_url, {
                //                 params: {
                //                     customer_group_id: $('#inputCustomerGroup')[0].selectize.getValue(),
                //                     quantity: 1
                //                 }
                //             }).then((response) => {
                //                 $(".inputItemPrice", $item).val(response.data.price);
                //             })
                //         }
                //     }
                // });


                if (OrderValidation.generalValidation($('#orderForm')))
                    RunningTotals.taxAndTotals($productRepeater.children().last().children().last().children().last().children());

                JsLoadingOverlay.hide();


                //   Setup stripe intent for customer
                $('.initPayment').click(function () {
                    JsLoadingOverlay.show();
                    $('[data-stripe="payment_method"]').attr('data-secret', ' ')
                    Stripe.getSetupIntent($('#inputCompany')[0].selectize.getValue(), value)
                });
            },
            render: {
                option: function (item, escape) {
                    return '<div class="option customerOrderOption">' +
                        '<span class="customerOrderOptionName">' + item.fullname + " </span>" +
                        ( item.billing_address && item.billing_address.address.postcode ? " - <span class='customerOrderOptionPostcode'>" + item.billing_address.address.postcode + '</span>' : '') +
                        '</div>';

                }
            },
        }
    }

    static billingAddressOrder(params) {
        return {
            onChange: function (value) {
                let $billingEditBtn = $('#inputBillingEditBtn');

                if (value) {

                    $('.shippingAddress').show()


                    if ($('#inputShipping').val() === '') {
                        $('#replicate_billing').click()
                    }
                    else if ($('#replicate_billing').is(':checked')) {
                        $('#inputShipping')[0].selectize.setValue($('#inputBilling').val());
                    }

                    let address = this.options[value]

                    if(address.can_update){
                        $billingEditBtn.removeClass('disabled');
                        $billingEditBtn.prop('href', '/customers/' + $('#inputCustomer').val() + '/addresses/' + value + '/edit');
                    } else {
                        $billingEditBtn.addClass('disabled');
                    }

                } else {
                    $billingEditBtn.addClass('disabled')
                    $('.shippingAddress').hide()
                }
            }
        }
    }

    static shippingAddressOrder(params) {
        return {
            onChange: function (value) {
                let $shippingEditBtn = $('#inputShippingEditBtn');
                if (value) {

                    if($('#replicate_billing').length && !$('#replicate_billing').is(':checked')){
                        let address = this.options[value]

                        if(address.can_update){
                            $shippingEditBtn.removeClass('disabled');
                            $shippingEditBtn.prop('href', '/customers/' + $('#inputCustomer').val() + '/addresses/' + value + '/edit');
                        } else {
                            $shippingEditBtn.addClass('disabled');
                        }
                    }
                        // $shippingEditBtn.removeClass('disabled');
                    // $shippingEditBtn.prop('href', '/customers/' + $('#inputCustomer').val() + '/addresses/' + value + '/edit');

                } else {
                    $shippingEditBtn.addClass('disabled')
                }
            }
        }
    }

    static itemsSearch(params, $element) {
        return {
            delimiter: ',',
            persist: false,
            preload: false,
            placeholder: 'Type product name, tag name, description or category',
            searchField: ['title', 'sku'],
            sortField: [{field: 'title', direction: 'asc'}],
            create: function (input) {
                if (input) {
                    $('#addProductBtn').prop('disabled', false);
                } else {
                    $('#addProductBtn').prop('disabled', true);
                }
                return {
                    title: input,
                    type: 'misc'
                }
            },
            onType: function (str) {
                if (str) {
                    $('#addProductBtn').prop('disabled', false);
                } else {
                    $element[0].selectize.clearOptions();
                    $element[0].selectize.close();
                    $('#addProductBtn').prop('disabled', true);
                }
            },
            onChange: function (value) {
                if (value) {
                    $('#addProductBtn').prop('disabled', false);
                } else {
                    $element[0].selectize.clearOptions();
                    $element[0].selectize.close();
                    $('#addProductBtn').prop('disabled', true);

                }
            },
            render: {
                option_create: function (data, escape) {
                    return '<div class="create">Create Misc Product: <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                },
                option: function (item, escape) {

                    let tags = '';
                    if (item.type === 'products') {
                        let tempDescription = document.createElement("div");
                        tempDescription.innerHTML = item.searchable.description ? item.searchable.description.content : '';

                        item.searchable.tags.map(function (value, index) {
                            tags += `<span class="badge badge-pill badge-primary">${value.name}</span>`;
                        })
                        return '<div class="container-fluid"><div class="row">' +
                            '<div class="col-12">' +
                            '<span class="title">' +
                            '<span class="name"><strong>' + escape(item.searchable.name) + ' (' + escape(item.searchable.sku) + ')' + '</strong></span>' +
                            '</span><br>' +
                            '</div>' +
                            '</div></div></div>';
                    } else if ((item.type === 'tags' || item.type === 'product_descriptions') && item.searchable.product !== null) {
                        let tempDescription = document.createElement("div");
                        tempDescription.innerHTML = item.searchable.product.description.content ?? '';

                        item.searchable.product.tags.map(function (value, index) {
                            tags += `<span class="badge badge-pill badge-primary">${value.name}</span>`;
                        })
                        return '<div class="container-fluid"><div class="row">' +
                            '<div class="col-4">' +
                            '<img class="w-100" src="' + (item.searchable.product.main_image.length > 0 ? item.searchable.product.main_image[0].url : ' ') + '">' +
                            '</div>' +
                            '<div class="col-8">' +
                            '<span class="title">' +
                            '<span class="name"><strong>' + escape(item.searchable.product.name) + '</strong></span>' +
                            '</span><br>' +
                            '</div>' +
                            '</div></div></div>';
                    } else {
                        return '<div></div>';
                    }
                }
            },
        }
    }

    static paymentType(params) {

        return {
            delimiter: ',',
            persist: false,
            valueField: 'value',
            labelField: 'text',
            searchField: 'text',
            placeholder: 'Select Payment Method',
            options: [
                {value: 'pro_forma', text: 'Proforma'},
                {value: 'Stripe', text: 'Stripe', disabled: true},
                {value: 'BACS', text: 'BACS'},
                {value: 'Purchase Order', text: 'Purchase Order'},
                {value: 'Cash', text: 'Cash'},
                {value: 'Card Terminal', text: 'Card Terminal'},
                {value: 'Cheque', text: 'Cheque'}
            ],
            render: {
                option: function (item, escape) {
                    if (item.disabled) {
                        return '<div class="option" style="pointer-events: none; color: #aaa;" disabled="true">' + escape(item.text) + '</div>';
                    }

                    return '<div class="option">' + escape(item.text) + '</div>';
                },
            },
            onChange: function (value) {
                if (value === 'Stripe') {
                    $('[data-stripe-container]').show();
                } else {
                    $('[data-stripe-container]').hide();
                }
                if (value === 'Card Terminal') {
                    $('[data-card-terminal-container]').show()
                } else {
                    $('[data-card-terminal-container]').hide()
                }
                if (value === 'Purchase Order') {
                    $('[data-purchase-order-container]').show()
                } else {
                    $('[data-purchase-order-container]').hide()
                }
            }
        }
    }

    static optGroup() {

    }

    static suppliersInput() {
        $('#inputStockAmount').on('keyup change', function () {
            let stockAmount = $(this).val();
            if (stockAmount < 0) {
                $('#inputSupplierID').hide();
            } else {
                $('#inputSupplierID').show();
            }
        });
    }

    static shippingMethods(params, $element) {
        return {
            onChange: function (value) {
                let optionSelected = this.options[value];

                $('.inputItemPrice', $element.parent().parent()).val(optionSelected.rate);
                RunningTotals.initRunningTotals($('body'));

                if (window.location.href.indexOf("refunds") <= -1)
                    RunningTotals.taxAndTotals($("[data-init='initJRepeaterProducts']").children().last().children());
            }
        }
    }

    static addressContact(params, $element) {
        return {
            sortField: [{field: 'value', direction: 'desc'}],
            onChange: function (value) {
                if (isNaN(value)) {
                    $('.newContact').show();
                } else {
                    $('.newContact').hide();
                }
            }
        }
    }

    static fulfilment(params, $element) {
        return {
            valueField: 'id',
            labelField: 'name',
            searchField: ['name'],
            sortField: [{field: 'value', direction: 'asc'}],
            maxItems: 1,
            create: false,
            onChange: function (value) {
                if (window.location.href.indexOf("refunds") <= 1) {
                    let $parent = $(this)[0].$wrapper.parents('.location-information');
                    let $inputSupplier = $('.inputSupplier', $parent);
                    if (value === 'direct-from-supplier') {
                        // console.log($inputSupplier[0].selectize.$wrapper, 'direct')
                        $inputSupplier[0].selectize.$wrapper.show();
                        $inputSupplier[0].selectize.enable();
                    } else {
                        // console.log($inputSupplier[0].selectize.$wrapper, 'non direct')
                        $inputSupplier[0].selectize.$wrapper.hide();
                        $inputSupplier[0].selectize.disable();
                    }
                }
            },
            render: {
                option: function (item, escape) {
                    return '<div class="container"><div class="row">' +
                        '<div class="col-8">' +
                        '<span class="name"><strong>' + item.name + '</strong></span>' +
                        '</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        (item.count ? '<span class="badge badge-pill badge-info">' + item.count + ' in stock</span>' : '') +
                        '</span>' +
                        '</div>' +
                        '</div></div>';
                }
            },
            load: function(query, callback) {
                let sAPI = $element[0].selectize, $repeaterEl = $element.parents('[data-repeater-item]'),
                    $qtyEl = $('.inputQuantity', $repeaterEl);

                let params = {
                    'quantity': $qtyEl.val()
                }

                Dropdowns.selectizeAxiosLoad($element, $element.data('src'), sAPI, callback, query, params);
            },
        }
    }

    static stockLocationCreate(params) {
        return {
            create: function (input) {
                axios.post('/products/stock-locations', {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    name: input
                }).then((response) => {
                    this.addOption(response.data.session.stockLocation);
                    this.addItem(response.data.session.stockLocation.id);
                    this.setValue(response.data.session.stockLocation.id);
                })
            }
        }
    }

    static supplierCreate(params, $element) {

        return {
            create: function (input) {
                Modals.show('/products/suppliers/create', 'addSupplierCard', false, function (modal) {
                    let name = input;

                    if (name !== typeof undefined)
                        modal.find('[name="name"]').val(name)

                    modal.find('form').attr('data-on-success', 'supplierCreateSelectize');
                    modal.find('form').attr('data-selectize-name', $element.attr('name'));
                });
            }
        }
    }

    static customerGroups(params, $element) {
        return {
            load: function (query, callback) {
                let sAPI = $element[0].selectize;
                Dropdowns.selectizeAxiosLoad($element, $element.data('src'), sAPI, function (data) {
                    callback(data);
                    data.forEach(function (customerGroup) {
                        if (customerGroup.default && $element.val() === '' && $element.data('selected') == '')
                            sAPI.setValue(customerGroup.id);

                    })
                }, query);
            },
            onChange: function (value) {

                JsLoadingOverlay.show();
                let list = $('[data-repeater-list="items"]').children();

                list.each((index, $item) => {
                    if (index !== 0) {
                        let itemType = $('.itemType', $item).val();
                        let productID = $('.itemID', $item).val();
                        if (itemType === 'product') {
                            let price_api_url = `/api/products/get-price/${productID}`;
                            axios.get(price_api_url, {
                                params: {
                                    customer_group_id: $('#inputCustomerGroup').val(),
                                    quantity: 1
                                }
                            }).then((response) => {
                                $(".inputItemPrice", $item).val(response.data.price);
                                RunningTotals.taxAndTotals($("[data-init='initJRepeaterProducts']").children().last().children().last().children().last().children());
                                JsLoadingOverlay.hide();
                            })
                        }
                    }
                });


                JsLoadingOverlay.hide();

            }

        }
    }

    /**
     * Product search on stock order.
     * More JS logic for adding a product repeater item in StockOrders.js
     *
     * @param params
     * @param $element
     * @returns {{onChange: onChange, placeholder: string, render: {option: function(*, *): (string|string)}}}
     */
    static itemsSearchStockOrder(params, $element) {
        return {
            onChange: function (value) {
                if (value) {
                    $('#addProductBtn').prop('disabled', false);
                } else {
                    $('#addProductBtn').prop('disabled', true);
                }
            },
            placeholder: 'Type product name, tag name, description or category',
            render: {
                ...this.productSearchOption()
            }
        }
    }


    /** Product search option layout */
    static productSearchOption() {
        return {
            option: function (item, escape) {
                let tags = '';
                if (item.type === 'products') {
                    let tempDescription = document.createElement("div");
                    tempDescription.innerHTML = item.searchable.description ? item.searchable.description.content : '';

                    item.searchable.tags.map(function (value, index) {
                        tags += `<span class="badge badge-pill badge-primary">${value.name}</span>`;
                    })
                    return '<div class="container-fluid"><div class="row">' +
                        '<div class="col-4">' +
                        '<img class="w-100" src="' + (item.searchable.main_image[0] ? item.searchable['main_image'][0].url : ' ') + '">' +
                        '</div>' +
                        '<div class="col-8">' +
                        '<span class="title">' +
                        '<span class="name"><strong>' + escape(item.searchable.name) + '</strong></span>' +
                        '</span><br>' +
                        tags + '<br>' +
                        '<span class="description">' + tempDescription.textContent.substring(0, 50) + '...' + '</span>' +
                        '</div>' +
                        '</div></div></div>';
                } else if ((item.type === 'tags' || item.type === 'product_descriptions') && item.searchable.product !== null) {
                    let tempDescription = document.createElement("div");
                    tempDescription.innerHTML = item.searchable.product.description.content ?? '';

                    item.searchable.product.tags.map(function (value, index) {
                        tags += `<span class="badge badge-pill badge-primary">${value.name}</span>`;
                    })
                    return '<div class="container-fluid"><div class="row">' +
                        '<div class="col-4">' +
                        '<img class="w-100" src="' + (item.searchable.product.main_image.length > 0 ? item.searchable.product.main_image[0].url : ' ') + '">' +
                        '</div>' +
                        '<div class="col-8">' +
                        '<span class="title">' +
                        '<span class="name"><strong>' + escape(item.searchable.product.name) + '</strong></span>' +
                        '</span><br>' +
                        tags + '<br>' +
                        '<span class="description">' + tempDescription.textContent.substring(0, 50) + '...' + '</span>' +
                        '</div>' +
                        '</div></div></div>';
                } else {
                    return '<div></div>';
                }
            }
        }
    }

    static supplierStockOrder(params, $element) {
        return {
            placeholder: 'Search for suppliers',
            render: {
                option: function (item, escape) {
                    return '<div class="option supplierOption">' +
                        '<span class="supplierOptionName">' + item.name + " </span>" +
                        " - " +
                        "<span class='supplierOptionCost'> £" + item.pivot.cost + '</span>' +
                        '</div>'

                }
            },
            onChange: function (value) {
                let optionSelected = this.options[value],
                    $newPriceInput = $('[name*="new_price"]', $(this.$wrapper).closest('tr'));

                $newPriceInput.val(optionSelected.pivot.cost)
            }
        }
    }

    static creditNotesOrder(params, $element) {
        return {
            render: {
                option: function (item, escape) {
                    return '<div class="option creditNoteOption">' +
                        '<span class="creditNoteOptionName">' + item.reference + " </span>" +
                        " - " +
                        "<span class='creditNoteOptionValue badge badge-secondary'>Credit £" + item.remaining_balance + '</span>' +
                        '</div>'

                }
            }
        }
    }

    static orderStatus(params, $element) {
        return {
            onChange: function (value) {
                let optionSelected = this.options[value];
                if (confirm(`Confirm to move the order status to ${optionSelected.label.toLowerCase()}`)) {
                    axios.patch(`/order-processing/${$element.data('order-id')}`, {status: optionSelected.name})
                        .then(response => {
                                Alerts.success('Order status changed to ' + optionSelected.label.toLowerCase())
                            }
                        )
                }
            }
        }
    }

    static orderType(params, $element) {
        return {
            onChange: function (value) {
                // if (value === 'telephone') {
                //     $('#addShippingBtn').trigger('click');
                // }
            }
        }
    }

    static categoryChannels(params, $element) {
        return {
            onChange: function (value) {
                let $categoryChannels = $('#categoryChannels'), $categoryApi = $categoryChannels[0].selectize;

                $categoryChannels.data('src', '/api/channels?parent=' + value);
                $categoryApi.destroy();

                Dropdowns.initSelectizeHandler($categoryChannels);
            }
        }
    }

    static processingOrderStockLocation(params, $element) {
        return {
            render: {
                option: function (item, escape) {
                    return '<div class="container"><div class="row">' +
                        '<div class="col-8">' +
                        '<span class="name"><strong>' + item.name + '</strong></span>' +
                        '</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        (item.count ? '<span class="badge badge-pill badge-info">' + item.count + ' in stock</span>' : '') +
                        '</span>' +
                        '</div>' +
                        '</div></div>';
                }
            }
        }
    }
}
